import { useState, useEffect, useRef } from "react";
import { Wrapper, PanelContext } from "nystem-components";
import app from "nystem";

const types = {
  default: {
    wrapper: "mb-3 rounded border border-gray-200 bg-white shadow-sm",
    body: "m-3",
    header: "pointer rounded bg-gray-50 p-2 text-gray-700",
  },
  primary: {
    wrapper: "mb-3 border shadow rounded bg-blue-600 border-blue-600",
    body: "p-3 bg-white rounded",
    header: "text-white pointer p-1 pl-3",
  },
  defaultWithoutPadding: {
    wrapper: "mb-3 rounded border border-gray-200 bg-white shadow-sm",
    body: "",
    header: "pointer rounded bg-gray-50 px-2 py-1 text-gray-700",
  },
  compact: { wrapper: "", body: "", header: "" },
};

const Panel = ({ body, header, className, expandedClass, ...props }) => {
  const [expanded, setSexpanded] = useState(props.expanded);
  const panelElement = useRef(null);

  const toggleExpand = () => {
    setSexpanded(!expanded);
    app.stateStore.set(panelElement, !expanded, props.stateStore);
  };

  useEffect(() => {
    const storedState = app.stateStore.get(panelElement, props.stateStore);
    if (storedState === null || storedState === expanded) return;
    setSexpanded(storedState);
  }, [expanded, props.stateStore]);

  const type = types[props.type || "default"];
  const hiddenClass = !expandedClass && "hidden";

  const head = (
    <Wrapper className={type.header}>
      <PanelContext.Provider value={{ toggleExpand, expanded }}>{header}</PanelContext.Provider>
    </Wrapper>
  );

  return (
    <Wrapper
      ref={panelElement}
      className={[type.wrapper, className, expanded && expandedClass]}
      renderAs={props.renderAs}
    >
      {!props.posthead && head}
      {expanded ? (
        <Wrapper className={type.body}>{body}</Wrapper>
      ) : props.visibilityHidden ? (
        <Wrapper className={[type.body, hiddenClass]}>{body}</Wrapper>
      ) : null}
      {props.posthead && head}
    </Wrapper>
  );
};

export default Panel;
